<div class="container">
    <div class="card">
      <div class="card-header">
        Firebase Cloud Storage & Angular 5
      </div>
      <div class="card-body">
        <h5 class="card-title">Select a file for upload:</h5>
        <input type="file" (change)="upload($event)" accept=".png,.jpg" />
        <br><br>
        <div class="progress">
          <div class="progress-bar progress-bar-striped bg-success" role="progressbar" [style.width]="(uploadProgress | async) + '%'" [attr.aria-valuenow]="(uploadProgress | async)" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
        <br>
        <div *ngIf="downloadURL | async; let downloadSrc" class="alert alert-info" role="alert">
            File uploaded: <a [href]="downloadSrc">{{downloadSrc}}</a>
        </div>
        <br>
        <div class="btn-group" role="group" *ngIf="uploadState | async; let state">
            <button type="button" class="btn btn-primary" (click)="task.pause()" [disabled]="state === 'paused'">Pause</button>
            <button type="button" class="btn btn-primary" (click)="task.cancel()" [disabled]="!(state === 'paused' || state === 'running')">Cancel</button>
            <button type="button" class="btn btn-primary" (click)="task.resume()" [disabled]="state === 'running'">Resume</button>
        </div>
      </div>
    </div>
  </div>